import { render } from "./NewsList.vue?vue&type=template&id=5e77b7ab&scoped=true&ts=true"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"

import "./NewsList.vue?vue&type=style&index=0&id=5e77b7ab&lang=scss&scoped=true"
import "./NewsList.vue?vue&type=style&index=1&id=5e77b7ab&lang=scss"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e77b7ab"]])

export default __exports__